<template>
    <div class="XR-load-more" @touchstart="touchStart($event)" @touchend="touchEnd($event)">
        <div class="inner">
            <div class="scroll-content">
                <slot></slot>
            </div>
            <div class="load-more" v-show="enableLoadMore">{{loadMoreText}}</div>  
            <div class="load-nomore" v-show="!enableLoadMore"><img src="/static/refresh/more.png" class="nomore_logo">亲，暂无更多</div>
        </div>
    </div>
</template>


<script>
export default {
    name: "XR-load-more",
    props: {
        enableLoadMore: {
            type: Boolean,
            default: true
        }, 
        onLoadMore: {
            type: Function,
            default: undefined,
            require: false
        }
    },
    data() {
        return {
            loadMoreText: "上拉加载更多",
            startX: 0,
            startY: 0,
            isLoading: false,
        }
    }, 
    methods: {
        touchStart(e) {
            this.startY = e.targetTouches[0].pageY;
            this.startX = e.targetTouches[0].pageX;  
        },
        scrollToEnd(e) {
            let clientHeight = document.documentElement.clientHeight; 
            let elzoomInfo = this.$el.getBoundingClientRect();  
            if(!this.enableLoadMore){
                return
            }
            var nowspace=elzoomInfo.bottom -clientHeight
            if (-10<= nowspace && nowspace <= 10) {
                console.info("enableLoadMore："+ this.enableLoadMore)
                this.doLoadMore()
            } 
        },
        touchEnd(e) {
            if (this.isLoading) {
                return;
            }

            let endX = e.changedTouches[0].pageX,
                    endY = e.changedTouches[0].pageY,
                    dy = this.startY - endY,
                    dx = endX - this.startX;
            if(Math.abs(dx) < 2 && Math.abs(dy) < 2) {
                return;
            }
            if (endY < this.startY) {
                this.scrollToEnd(e)
            }
        },
        doLoadMore() {
            this.isLoading = true
            this.loadMoreText = '加载中...'
            this.onLoadMore(this.loadDone);
        },
        loadDone() {
            this.isLoading = false;
            this.loadMoreText = '上拉加载更多'
        }
    }
}
</script>

<style>
.XR-load-more {
  overflow: hidden;
  -webkit-overflow-scrolling: touch;
  transition-duration: 300ms;  
}  
.XR-load-more .inner {
}
.XR-load-more .inner .scroll-content{
  overflow: hidden;
}
.XR-load-more .load-more,.XR-load-more .load-nomore{
    margin: 25px 0 30px;
    height: 35px;
    line-height: 35px;
    display: flex;
    font-size: 12px;
    color: #aaa;
    align-items: center;
    justify-content: center;
}
 .XR-load-more .load-nomore .nomore_logo {
    display: block;
    height: 35px;
    background-size: 100%;
}

</style>


// WEBPACK FOOTER //
// src/components/loadmore/loadmore.vue